import * as yup from 'yup';
import { PlayerAdcType } from "../../../common/enums/playerAdcTypes";
import { Gender } from "../../../common/enums/Gender";
import type { DartsPlayerFormValues } from './DartsPlayersCRUD.types';

export const schema = yup.object<DartsPlayerFormValues>().shape({
    name: yup.string().required(),
    surname: yup.string().required(),
    nickname: yup.string().nullable(),
    abbr: yup.string().nullable().max(3),
    displayname: yup.string().nullable().max(24),
    hometown: yup.string().required().min(2),
    nationality: yup.string().required().min(2),
    dartsUsed: yup.string().required().min(2),
    careerBest: yup.string().required().min(2),
    gender: yup.mixed<Gender>().nullable().transform((value, originalValue) => originalValue === '' ? null : (Number(originalValue) ?? null))
        .oneOf(
            Object.values(Gender).filter(v => typeof v === 'number') as Gender[],
            'Gender'
    ),
    adcQualifier: yup.mixed<PlayerAdcType>().nullable().transform((value, originalValue) => originalValue === '' ? null : (Number(originalValue) ?? null))
        .oneOf(
            Object.values(PlayerAdcType).filter(v => typeof v === 'number') as PlayerAdcType[],
            'Invalid ADC qualifier'
    )
});


/*
export const schema: yup.ObjectSchema<DartsPlayerFormValues> = yup.object().shape({

...

    adcQualifier: yup.mixed<PlayerAdcType>().nullable().transform((value, originalValue) => (originalValue === '' ? null : (Number(originalValue) ?? null)))
        .oneOf(
            Object.values(PlayerAdcType).filter(v => typeof v === 'number') as PlayerAdcType[],
            'Invalid ADC qualifier'
        )

    adcQualifier: yup.mixed<PlayerAdcType>().nullable()


 */